import { InventoryAdjustment } from '@givebacks/api/store';
import { DateTime } from 'luxon';

import { createColumnHelper } from '../../../../../hooks/tables';
import { InventoryAdjustmentIncrementBadge } from '../InventoryAdjustmentIncrementBadge/InventoryAdjustmentIncrementBadge';

const columnHelper = createColumnHelper<InventoryAdjustment>();

const inventoryAdjustmentsColumns = [
  columnHelper.accessor('updated_at', {
    header: 'Date',
    size: 300,
    enableSorting: false,
    cell: (props) => {
      const date = DateTime.fromJSDate(new Date(props.row.original.updated_at));

      const formattedDate = date.toFormat('MM/dd/yyyy');
      const formattedTime = date.toFormat('h:mm a');

      return `${formattedDate} at ${formattedTime}`;
    },
  }),
  columnHelper.accessor('user', {
    header: 'Adjusted By',
    size: 200,
    enableSorting: false,
    cell: (props) => {
      const user = props.row.original.user;

      return user?.email ?? '--';
    },
  }),
  columnHelper.accessor('made_by_type', {
    header: 'Type',
    size: 200,
    enableSorting: false,
    cell: (props) => {
      const type = props.row.original.made_by_type;

      return type === 'User' ? 'Manual' : 'Purchase';
    },
  }),
  columnHelper.accessor('amount', {
    header: 'Increment',
    size: 200,
    enableSorting: false,
    cell: (props) => {
      return <InventoryAdjustmentIncrementBadge amount={props.row.original.amount} />;
    },
  }),
];

export { inventoryAdjustmentsColumns };
